import { render, staticRenderFns } from "./chevron-right.vue?vue&type=template&id=6b6a6dec&"
import script from "./chevron-right.vue?vue&type=script&lang=js&"
export * from "./chevron-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6a6dec')) {
      api.createRecord('6b6a6dec', component.options)
    } else {
      api.reload('6b6a6dec', component.options)
    }
    module.hot.accept("./chevron-right.vue?vue&type=template&id=6b6a6dec&", function () {
      api.rerender('6b6a6dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/chevron-right.vue"
export default component.exports